import { hasToForceUserToSignForms } from '../common/commomUtil.js';
import * as ActionTypes from './actionTypes.js';
import extend from 'lodash/extend';

const initialState = { isSimulation: false };
export default function homeReducers(state = initialState, action) {
  let bpUserInfo = Object.assign({}, { ...(state.bpUserInfo || {}) });
  switch (action.type) {
    case ActionTypes.USER_SIMULATION_DATA:
    case ActionTypes.SET_MULTIPLE_DELEGATE:
    case ActionTypes.GET_USER_LIST:
    case ActionTypes.HOME_AUTHENTICATE_USER:
    case ActionTypes.HOME_CLIENT_CONFIG:
    case ActionTypes.HOME_AUTHORIZATION_ERROR:
    case ActionTypes.HOME_CLIENT_CONFIG_FETCH_ERROR:
    case ActionTypes.HOME_ERRORMAP_CONFIG:
    case ActionTypes.HOME_ERRORMAP_CONFIG_FETCH_ERROR:
    case ActionTypes.USER_ACCESS_LEVELS:
    case ActionTypes.SET_LD_FLAGS:
    case ActionTypes.UPDATE_CONTACT_INFO:
    case ActionTypes.SET_BRAND_CONFIGS:
      return extend({}, state, action.payload);
    case ActionTypes.SHOW_SQ_SIDEBAR:
      return extend({}, state, action.payload, { isSqSidebarShown: action.payload.isSqSidebarShown });

    case ActionTypes.PERSIST_SIMULATION_INFO:
      return extend({}, state, action.payload, { isSsoLogin: true });

    case ActionTypes.HOME_SET_LOGGEDINUSER_ROLES: {
      const USER_INFO = Object.assign({}, action.payload);
      return extend({}, state, { bpUserInfo: USER_INFO, isSsoLogin: true });
    }
    case ActionTypes.HOME_SET_LOGGEDINUSER_INFO:
      return Object.assign({}, state, {
        bpUserInfo: Object.assign(
          {},
          { ...state.bpUserInfo },
          { profileObj: action.payload.data, isSimulation: false }
        ),
        bpUserEnforceToSignForms: hasToForceUserToSignForms(
          state?.bpUserAppointmentInfo?.mandatoryAppointments,
          action.payload?.data?.profile
        ),
      });
    case ActionTypes.HOME_SET_MANDATORY_APPOINTMENT_INFO:
      return Object.assign({}, state, {
        bpUserAppointmentInfo: Object.assign({}, { mandatoryAppointments: action.payload }),
        bpUserEnforceToSignForms: hasToForceUserToSignForms(action.payload, state?.bpUserInfo?.profileObj?.profile),
      });
    case ActionTypes.HOME_SET_SIMULATIONUSER_INFO:
      return extend({}, state, {
        bpUserInfo: Object.assign(
          {},
          { ...state.bpUserInfo },
          {
            profileObj: action.payload.data,
            isSimulation: true,
            // We'll fallback to PtbSimulationHeader when Home Controlelr is trying to read userprofile from simulation cookie (PTB)
            simulationHeader: action.payload?.simulationHeader || state.bpUserInfo?.ptbSimulationHeader,
          }
        ),
        bpUserEnforceToSignForms: hasToForceUserToSignForms(
          state?.bpUserAppointmentInfo?.mandatoryAppointments,
          action.payload?.data?.profile
        ),
      });

    case ActionTypes.RESET_HOME_REDUCER: {
      bpUserInfo = Object.assign({}, { ...state.bpUserInfo }, { profileObj: null, isSimulation: false });
      return extend({}, state, { bpUserInfo: bpUserInfo });
    }

    case ActionTypes.SWITCH_ASSIGNED_BROKER: {
      // Replace primary producer with selected TaxIds' primary
      bpUserInfo = state.bpUserInfo;
      if (bpUserInfo?.profileObj?.profile) {
        bpUserInfo.profileObj.profile.primaryProducer =
          state.bpUserInfo.profileObj.profile.primaryProducer || state.bpUserInfo.profileObj.profile.producer;
        bpUserInfo.profileObj.profile.producer = action.payload.data.profile.producer;
      }
      bpUserInfo.profileObj.agentSelected = true;

      // const ORIGINAL_PRIMARY = state.bpUserInfo.profileObj.profile.primaryProducer || state.bpUserInfo.profileObj.profile.producer;
      // let NEW_BPUSERPROFILEOBJ = Object.assign({}, { ...state.bpUserInfo.profileObj.profile.producer }, {
      //     ...action.payload.data.profile.producer, switchBroker: true
      // });
      // bpUserInfo = Object.assign({}, { ...state.bpUserInfo }, { profileObj: { profile: NEW_BPUSERPROFILEOBJ, primaryProducer: ORIGINAL_PRIMARY } });
      return extend({}, state, { bpUserInfo });
    }

    // We should reset the profileObj once user switches to /admin page, so that no trails fo the simulation exists
    case ActionTypes.HOME_RESET_SIMULATIONUSER_INFO: {
      let originalBpUserInfo = state.bpUserInfo;
      if (originalBpUserInfo) {
        delete originalBpUserInfo['profileObj'];
        originalBpUserInfo.isSimulation = false;
        delete originalBpUserInfo['simulationHeader'];
      }

      return extend({}, state, { bpUserInfo: originalBpUserInfo });
    }

    case ActionTypes.UPDATE_HIPPA_USER_PROFILE: {
      bpUserInfo = state.bpUserInfo;
      if (bpUserInfo?.profileObj?.profile) {
        bpUserInfo.profileObj.profile.hipaaAttestationStatus =
          action.payload.hipaaAttestationStatus ?? bpUserInfo.profileObj.profile.hipaaAttestationStatus;
        bpUserInfo.profileObj.profile.displayHipaaFlag =
          action.payload.displayHipaaFlag ?? bpUserInfo.profileObj.profile.displayHipaaFlag;
        bpUserInfo.profileObj.profile.invalidPeriod =
          action.payload.invalidPeriod ?? bpUserInfo.profileObj.profile.invalidPeriod;
        bpUserInfo.profileObj.profile.displayCampaignFlag =
          action.payload.displayCampaignFlag ?? bpUserInfo.profileObj.profile.displayCampaignFlag;
        bpUserInfo.profileObj.pwdPromotionData.hasPasswordLessEnabled =
          action.payload.pwdPromotionStatus ?? bpUserInfo.profileObj.pwdPromotionData.hasPasswordLessEnabled;
      }
      return extend({}, state, { bpUserInfo });
    }

    case ActionTypes.HOME_SET_ACE_PROFILE:
      return extend({}, state, action.payload);

    case ActionTypes.HOME_FETCH_ACE_PROFILE_FAILED:
      return extend({}, state, { bpUserAceProfile: { isEliteBroker: false, profiles: [] } });

    case ActionTypes.HOME_ACE_SET_CONCIERGE_DETAIL: {
      if (state && state.bpUserAceProfile && state.bpUserAceProfile.profiles) {
        let owcsConciergeList = action.payload;
        let conciergeProfiles = state.bpUserAceProfile.profiles;
        conciergeProfiles.forEach(
          profile =>
            profile &&
            profile.concierge &&
            profile.concierge.forEach(concierge => {
              let conciergeDetail = owcsConciergeList
                ? owcsConciergeList.find(
                    owcsConcierge =>
                      concierge.owcsId &&
                      owcsConcierge.owcsId &&
                      owcsConcierge.owcsId
                        .toString()
                        .trim()
                        .toLowerCase() ===
                        concierge.owcsId
                          .toString()
                          .trim()
                          .toLowerCase()
                  )
                : null;
              concierge.detail = conciergeDetail ? Object.assign({}, conciergeDetail) : null;
              if (concierge.detail && concierge.detail.imageUrl) {
                concierge.detail.imageUrl = `/apps/ptb/api/ace/concierge/image?imageUrl=${concierge.detail.imageUrl}`;
              }
            })
        );
        state.bpUserAceProfile.conciergeDetailFetched = true;
        return extend({}, state);
      } else {
        return state;
      }
    }

    case ActionTypes.FETCH_USER_PRODUCER_DATA:
      return { ...state, ...{ BrokerProducerDetails: action.payload } };

    case ActionTypes.UPDATE_SET_SITE_ACCESS_FLAG:
      return { ...state, isEligibleToAccessSETSite: action.payload };

    default:
      return state;
  }
}
